// Route kontrakty — BYZNYSOVÁ DATA composition bodu pro SKUTEČNÉ TanStack routes.
//
// Účel: agreguje veřejné route kontrakty slices (`SliceRouteContract`) → `src/routes/*` wrappery
// z nich staví file-based routy, aniž by sáhly do slice internals. Tohle je JEDINÝ composition
// soubor, který smí drátovat slice `*Page` přes route kontrakt (viz výjimka v boundaries.test.ts).
//
// Native agendy už route NEMAJÍ — otevírají se přímo přes navigační kernel (search params), viz
// `nativeAgendaRegistry.ts`. Zde tedy zůstávají jen skutečné routy: 404 (`$`), design showcase a
// legacy-form. Baseline položky hlavního menu se přesunuly do `app/layout/mainMenuDefinitions.ts`.

import type { SliceRouteContract } from '@/shared/lib/vsa';

import { notFoundRouteContract } from '@/modules/not-found/routeContract';
import { designShowcaseRouteContract } from '@/modules/design-showcase';
import { legacyFormRouteContract } from '@/modules/legacy-form/routeContract';

export const routeContracts = {
  notFound: notFoundRouteContract,
  designShowcase: designShowcaseRouteContract,
  legacyForm: legacyFormRouteContract,
} as const satisfies Record<string, SliceRouteContract>;
